import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks } from "@/services/misc/functions/ValidationFunctions";

export class EditUserForm {
  public databaseId: number = 0;
  public password: string = '';
  public passwordConf: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    databaseId: [
      (v: number) => !!v || 'Database id is required',
      (v: number) => v > 0 || 'Database id must be greater than 0',
    ],
    password: [
      ...PasswordValidationCallbacks,
    ],
  };
}

